import React, { useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import { usePermissions } from "../contexts/PermissionContext";
import PageShell from "./PageShell";
import ExamGroupTab from "./ExamGroupTab";
import GradeScaleTab from "./GradeScaleTab";
import CoScholasticSubjectTab from "./CoScholasticSubjectTab";
import FooterFieldTab from "./FooterFieldTab";
import SubjectLayoutTab from "./SubjectLayoutTab";
import CardLayoutTab from "./CardLayoutTab";

/** Route: /reportcard/settings  – everything that shapes the dynamic report card */
const ReportCardSettings = () => {
  const { rolePermissions, userInfo } = usePermissions();
  const canEdit =
    userInfo?.userrole === "SYS_ADMIN" ||
    userInfo?.userrole === "ADMIN" ||
    !!rolePermissions?.Exam_List?.can_edit;
  const [tab, setTab] = useState("groups");

  return (
    <PageShell title="Report Card Settings">
      <Tabs activeKey={tab} onSelect={(k) => setTab(k)} className="mb-3" mountOnEnter>
        <Tab eventKey="groups" title="Exam Groups"><ExamGroupTab canEdit={canEdit} /></Tab>
        <Tab eventKey="grades" title="Grade Scales"><GradeScaleTab canEdit={canEdit} /></Tab>
        <Tab eventKey="subjects" title="Subject Layout"><SubjectLayoutTab canEdit={canEdit} /></Tab>
        <Tab eventKey="cosch" title="Co-Scholastic Subjects"><CoScholasticSubjectTab canEdit={canEdit} /></Tab>
        <Tab eventKey="footer" title="Report Footer"><FooterFieldTab canEdit={canEdit} /></Tab>
        <Tab eventKey="layout" title="Card Layout (Designer)"><CardLayoutTab canEdit={canEdit} /></Tab>
      </Tabs>
    </PageShell>
  );
};

export default ReportCardSettings;
